module.exports = __webpack_public_path__ + "img/bg13.cf86f998.png";